export default {
  id: 133,
  title: 'Target #133 - Spiral',
  url: 'https://cssbattle.dev/play/133',
  colors: ['#F5D6B4', '#D86F45'],
  solution:
    '<a a><a b><a c><a d><a e><style>[a],[c]{clip-path:inset(50% 0 0 0)}[b],[d]{clip-path:inset(0 0 50% 0)}[a],[e]{left:80}body{background:#f5d6b4}a{position:fixed}[a]{top:50;width:160;height:160;border:20px solid #d86f45;border-radius:9in}[b],[c]{left:120;border:20px solid #d86f45}[b]{top:70;width:120;height:120;border-radius:9in}[c]{top:90;width:80;height:80;border-radius:9in}[d]{top:110;left:160;width:40;height:40;border:20px solid #d86f45;border-radius:9in}[e]{top:140;width:20;height:20;border-radius:9in;background:#d86f45;box-shadow:80px 0 #d86f45}</style>',
}
